export const services = [
  {
    id: 1,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/877f2518d7d4d59c1bcbac21748acf556ec2de1e8d96aa4f2eb795b99ae383af.jpeg",
    title: "Landscape Design & Installation",
    description: "Transform your outdoor space with custom landscape design and professional installation tailored to Alberta's unique climate.",
    features: [
      "Custom landscape plans",
      "Hardscape installation (patios, walkways, retaining walls)",
      "Softscape design (plants, trees, shrubs)",
      "Irrigation system setup",
      "Year-round consultation"
    ],
    icon: "Sprout"
  },
  {
    id: 2,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/0840b97dcb534cf1d908249184efd61419df346242c3cc6b99be6f8cfbdf5d85.jpeg",
    title: "Garden Maintenance & Care",
    description: "Keep your landscape beautiful year-round with our comprehensive garden maintenance services.",
    features: [
      "Lawn mowing and edging",
      "Fertilization programs",
      "Weed removal",
      "Seasonal planting",
      "Mulching and soil care"
    ],
    icon: "Leaf"
  },
  {
    id: 3,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/80cf5fdb46cead6de7a0f80aed7cb1ec951a0c3df4fb6d191e7d69b9ba2cb320.jpeg",
    title: "Tree & Shrub Care",
    description: "Professional pruning and maintenance to ensure the health and beauty of your trees and shrubs.",
    features: [
      "Expert pruning and trimming",
      "Disease diagnosis and treatment",
      "Seasonal care programs",
      "Hedge trimming",
      "Tree and shrub removal"
    ],
    icon: "Trees"
  },
  {
    id: 4,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/7f0ae34cf25e301a53d3c0b794f9195ad4d6074e5acac7f07ffbfd7bef3b63a9.jpeg",
    title: "Spring & Fall Clean-Up",
    description: "Seasonal property preparation to keep your outdoor space pristine and ready for the next season.",
    features: [
      "Leaf and debris removal",
      "Garden bed preparation",
      "Power raking and dethatching",
      "Property waste disposal"
    ],
    icon: "Wind"
  },
  {
    id: 5,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/56662cecb3ff38a4adc35f20add64a6c5378f26e783fc6f01099258d2af0a56b.jpeg",
    title: "Snow Removal Services",
    description: "Professional commercial snow removal to keep your property safe and accessible throughout Alberta's harsh winters. SIMA ASM Certified.",
    features: [
      "HOAs and condominium complexes",
      "Commercial and retail properties",
      "Parking lot clearing and plowing",
      "Ice control and salting",
      "24/7 emergency service",
      "Seasonal contracts available"
    ],
    icon: "Snowflake",
    badge: "ASM Certified"
  },
  {
    id: 6,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/b78eddce3e4a53bdaa2c6fe4fbeeb1377598a69a7c072b9bdf0eb092c5d14661.jpeg",
    title: "Hardscaping & Construction",
    description: "Build lasting outdoor features with quality materials and expert craftsmanship.",
    features: [
      "Paver patios and walkways",
      "Retaining walls",
      "Fire pits and outdoor kitchens",
      "Decorative stone work",
      "Deck and fence installation"
    ],
    icon: "Hammer"
  },
  {
    id: 7,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/80712869cac5890bafda5ac4af1cfd6dbc899cc588c6f7c1d419e8cfd01d8589.jpeg",
    title: "Concrete & Decorative Finishes",
    description: "Upgrade your outdoor space with durable, professionally installed concrete solutions tailored to your home.",
    features: [
      "Stamped and exposed aggregate patios",
      "Driveways, walkways, and steps",
      "Garage floors and concrete pads",
      "Custom finishes and decorative concrete",
      "Residential and commercial installations"
    ],
    icon: "Layers",
    customPage: "/services/concrete"
  },
  {
    id: 8,
    heroImage: "https://static.prod-images.emergentagent.com/jobs/90e246be-0711-4e27-8caa-13f1ea345ba5/images/e9f8c25f10638ffa1c3e8e01c2ce0a50357a0f1e060c03011b0d0a7d2478a9d0.jpeg",
    title: "Christmas & Holiday Lighting",
    description: "Professional Christmas light installation for homes and businesses. Custom-designed displays using commercial-grade C9 bulbs and 5mm wide-angle LEDs, fully installed, maintained, and removed.",
    features: [
      "Custom design and full installation",
      "Commercial-grade C9 bulbs and 5mm wide-angle LEDs",
      "Roofline, tree wrapping, wreaths and garland",
      "Storefronts, HOAs, condos and private estates",
      "Season-long maintenance and takedown"
    ],
    icon: "Sparkles",
    customPage: "/services/holiday-lighting"
  }
];

export const companyValues = [
  {
    id: 1,
    title: "Reliability",
    description: "We show up when we say we will. From seasonal maintenance to emergency snow removal, you can count on us to deliver consistent, dependable service.",
    icon: "CheckCircle"
  },
  {
    id: 2,
    title: "Quality Craftsmanship",
    description: "Every project reflects our commitment to excellence. We use premium materials and proven techniques to create landscapes that stand the test of time.",
    icon: "Award"
  },
  {
    id: 3,
    title: "Community Pride",
    description: "As a family owned Alberta business, we take pride in beautifying our community and treating every client like a neighbor.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Honest Communication",
    description: "We believe in transparent pricing, clear timelines, and open dialogue. You'll always know what to expect from our team.",
    icon: "MessageSquare"
  },
  {
    id: 5,
    title: "Environmental Stewardship",
    description: "We're committed to sustainable practices that protect Alberta's natural beauty while creating stunning outdoor spaces.",
    icon: "Globe"
  },
  {
    id: 6,
    title: "Customer-Focused",
    description: "Your vision drives our work. We listen, adapt, and go the extra mile to exceed expectations on every project.",
    icon: "Heart"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Jennifer S.",
    location: "Calgary, AB",
    rating: 5,
    text: "True North transformed our backyard into an absolute oasis. The retaining wall and paver patio exceeded our expectations. Professional, punctual, and incredible attention to detail."
  },
  {
    id: 2,
    name: "Michael R.",
    location: "Airdrie, AB",
    rating: 5,
    text: "Their snow removal service is outstanding. All winter long, they kept our driveway and walkways clear, often before we even woke up. Peace of mind during Alberta winters!"
  },
  {
    id: 3,
    name: "Sarah T.",
    location: "Red Deer, AB",
    rating: 5,
    text: "We've used True North for garden maintenance for two years now. Our lawn has never looked better, and their seasonal clean-up service is worth every penny. Highly recommend!"
  },
  {
    id: 4,
    name: "David L.",
    location: "Cochrane, AB",
    rating: 5,
    text: "From design to installation, True North was fantastic. They understood our vision and brought it to life with quality materials and expert workmanship. Our property value has definitely increased!"
  },
  {
    id: 5,
    name: "Patricia M.",
    location: "Okotoks, AB",
    rating: 5,
    text: "The team at True North pruned our mature trees and shrubs with such care and expertise. They explained everything they were doing and left the property immaculate. True professionals."
  },
  {
    id: 6,
    name: "Robert K.",
    location: "Chestermere, AB",
    rating: 5,
    text: "Reliable, honest, and skilled. True North has handled everything from spring clean-up to major landscaping projects for us. They're our go-to for all outdoor property needs."
  }
];

export const beforeAfterImages = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/zwexml0x_Messenger_creation_F47384AB-4BE2-46C3-8AB8-3117D4662BD1.jpeg",
    after: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/zwexml0x_Messenger_creation_F47384AB-4BE2-46C3-8AB8-3117D4662BD1.jpeg",
    title: "Retaining Wall & Garden Renovation",
    description: "Complete transformation with new retaining walls and landscaping"
  },
  {
    id: 2,
    before: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/3bi36ejy_Messenger_creation_2345E1A1-8F1F-4569-8FAE-EE70A0BB398F.jpeg",
    after: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/3bi36ejy_Messenger_creation_2345E1A1-8F1F-4569-8FAE-EE70A0BB398F.jpeg",
    title: "Yard Clean-Up & Restoration",
    description: "From overgrown to pristine outdoor living space"
  },
  {
    id: 3,
    before: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/63ulwzy1_Messenger_creation_AE8E585A-193C-4A72-8DC8-C620F35766D0.jpeg",
    after: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/63ulwzy1_Messenger_creation_AE8E585A-193C-4A72-8DC8-C620F35766D0.jpeg",
    title: "Front Yard Landscaping",
    description: "Enhanced curb appeal with professional landscaping"
  },
  {
    id: 4,
    before: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/7l79174s_Messenger_creation_7FF70CE2-AD37-4DCA-8F79-4E5F1736DF16.jpeg",
    after: "https://customer-assets.emergentagent.com/job_8e304dc6-e54e-4ab9-aee9-63cd271b5d31/artifacts/7l79174s_Messenger_creation_7FF70CE2-AD37-4DCA-8F79-4E5F1736DF16.jpeg",
    title: "Paver Patio Installation",
    description: "Complete backyard transformation with custom paver patio"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What landscaping services do you offer?",
    answer: "We provide full-service landscaping for both residential and commercial properties, including landscape design, installation, lawn care, planting, irrigation systems, outdoor lighting, hardscaping, concrete work, and ongoing maintenance. Our residential work ranges from single-family homes to private estates, and our commercial services cover office buildings, retail properties, and multi-unit complexes."
  },
  {
    id: 2,
    question: "How much does professional landscaping cost?",
    answer: "Landscaping costs vary based on property size, design complexity, materials, and features such as patios, lighting, or irrigation. We provide customized estimates for both residential and commercial projects after an on-site consultation."
  },
  {
    id: 3,
    question: "Do you work with high-end or luxury properties?",
    answer: "Yes. We specialize in upscale landscaping for both residential and commercial clients, including private estates, luxury homes, corporate campuses, and premium retail properties that require premium materials, detailed planning, and expert craftsmanship."
  },
  {
    id: 4,
    question: "How long does a landscaping project take?",
    answer: "Project timelines depend on scope and weather conditions. Smaller residential installations may take a few days, while full landscape transformations for larger residential or commercial properties can take several weeks. A detailed timeline is provided with your proposal."
  },
  {
    id: 5,
    question: "Do you offer landscape maintenance services?",
    answer: "Yes. We provide ongoing maintenance for residential and commercial properties including lawn care, pruning, seasonal cleanups, plant health care, irrigation checks, and property upkeep to keep landscapes looking their best year-round."
  },
  {
    id: 6,
    question: "What is included in landscape maintenance?",
    answer: "Maintenance typically includes mowing, edging, trimming, weed removal, fertilization, seasonal planting, and landscape health monitoring. Services can be customized for your residential or commercial property's specific needs."
  },
  {
    id: 7,
    question: "Do you install irrigation systems?",
    answer: "Yes. We design and install efficient irrigation systems for residential lawns, commercial properties, and large-scale landscapes. We also provide repairs and seasonal adjustments."
  },
  {
    id: 8,
    question: "Can you help increase my property's curb appeal?",
    answer: "Absolutely. Professional landscaping enhances curb appeal for homes and businesses alike, increases property value, and creates a welcoming outdoor environment for residents, customers, and visitors."
  },
  {
    id: 9,
    question: "Do you provide free landscaping estimates?",
    answer: "Yes. We offer consultations for both residential and commercial properties to assess your needs, discuss goals, and provide a detailed estimate for your landscaping project."
  },
  {
    id: 10,
    question: "Are you licensed, insured, and bonded?",
    answer: "Yes. Our company is fully licensed, insured, and bonded. This means we meet professional and legal requirements, maintain full liability protection, and provide financial security that projects are completed according to contract. Clients can expect transparency, accountability, and dependable service from start to finish."
  },
  {
    id: 11,
    question: "What areas do you service?",
    answer: "We proudly serve Calgary and surrounding areas for both residential and commercial clients. Contact us to confirm service availability in your specific location."
  },
  {
    id: 12,
    question: "Do you offer year-round services?",
    answer: "Yes! We provide landscaping services from spring through fall, and snow removal services throughout the winter months for both residential and commercial properties. We're your complete property maintenance solution all year long."
  },
  {
    id: 13,
    question: "Do you offer seasonal maintenance contracts?",
    answer: "Yes! We offer flexible seasonal and annual maintenance contracts for both residential and commercial properties. These contracts ensure priority service and consistent care for your landscape."
  },
  {
    id: 14,
    question: "What makes True North different from other landscaping companies?",
    answer: "Our commitment to quality, reliability, and honest communication sets us apart. We serve both residential and commercial clients with the same dedication. We're family owned and locally operated, use premium materials, and treat every property as if it were our own. Your satisfaction is our success."
  },
  {
    id: 15,
    question: "Do you install Christmas and holiday lights?",
    answer: "Yes. We provide professional Christmas light installation for residential and commercial properties across Calgary and surrounding areas. Our full-service holiday lighting includes custom design, installation, season-long maintenance, and takedown, so you never touch a ladder."
  },
  {
    id: 16,
    question: "What type of Christmas lights do you use?",
    answer: "We install commercial-grade products built for Alberta winters, including classic C9 LED bulbs for rooflines and 5mm wide-angle (conical) LED mini lights for tree wrapping, shrubs, and garland. These lights are energy-efficient, weather-rated, and available in warm white, pure white, multicolour, and custom colour combinations."
  },
  {
    id: 17,
    question: "Do you offer commercial holiday lighting for businesses, HOAs, and condos?",
    answer: "Absolutely. We design and install holiday lighting for storefronts, retail plazas, office buildings, restaurants, HOAs, and condominium complexes. Commercial displays are installed by insured professionals and include maintenance throughout the season to keep your property looking its best."
  },
  {
    id: 18,
    question: "When should I book Christmas light installation?",
    answer: "Installation typically runs from October through early December, and schedules fill quickly. We recommend booking in early fall to secure your preferred installation date. Contact us for details and availability."
  }
];